<template>
  <Datetime
    v-model="dt"
    :type="range ? type : type"
    :class="[customClass, 'date-time']"
    :use12h="false"
    :range="range"
    :clearable="false"
    :disabled-date="disabledDate"
    @change="onDateChange"
  >
    <!-- :disabled-time="disabledTime" -->
    <template #input>
      <v-text-field
        :value="formattedDate"
        dense
        :filled="filled"
        :outlined="outlined"
        :label="label"
        readonly
        class="abbas"
        :rules="rules"
        hide-details
      />
    </template>
    <template #icon-calendar>
      <i />
    </template>
  </Datetime>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import moment from "moment";

export default {
  components: { Datetime: DatePicker },
  props: {
    // form-field se styling ke liye white  background
    customClass: {
      type: String,
      default() {
        return "";
      },
    },
    type: {
      type: String,
      default() {
        return "datetime";
      },
    },
    value: {
      type: [String, Array],
      default() {
        return "";
      },
    },
    label: {
      type: String,
      default() {
        return "label";
      },
    },
    min: {
      type: String,
      default() {
        return "";
      },
    },
    max: {
      type: String,
      default() {
        return "";
      },
    },
    filled: {
      type: Boolean,
      default() {
        return true;
      },
    },
    outlined: {
      type: Boolean,
      default() {
        return false;
      },
    },
    range: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menu: false, // Control for v-menu visibility
      dt: this.range ? [] : "", // Raw date from the Datetime picker
    };
  },
  computed: {
    // formattedDate() {
    //   if (this.dt) {
    //     return moment(this.dt).format("DD-MMM-YYYY hh:mm:ss a");
    //   } else return "";
    // },
    formattedDate() {
      if (!this.dt) return "";
      const format =
        this.type == "date" ? "DD-MMM-YYYY" : "DD-MMM-YYYY hh:mm:ss a";
      // RANGE
      if (this.range && Array.isArray(this.dt)) {
        return this.dt.map((d) => moment(d).format(format)).join(" ~ ");
      }

      // SINGLE
      return moment(this.dt).format(format) || null;
    },
  },
  mounted() {
    if (this.value) {
      if (this.range && Array.isArray(this.value)) {
        this.dt = this.value.map((v) => new Date(v));
      } else {
        this.dt = new Date(this.value);
      }

      this.emitData();
    }
  },
  methods: {
    onDateChange(value) {
      if (value) {
        this.dt = value; // Update the raw date
        this.emitData();
      }
    },
    formatDate(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD hh:mm:ss a"); // Format using Moment.js
      }
      return "";
    },
    // disabledDate(dd) {
    //   // Agar From wala field hai to koi restriction nahi
    //   if (this.label === "From") {
    //     return false;
    //   }

    //   // Agar To wala field hai
    //   if (this.label === "To") {
    //     const from = this.min ? moment(this.min) : null; // yahan from date pass honi chahiye
    //     const date = moment(dd);

    //     if (from) {
    //       // agar from set hai to sirf us ke baad ke dates enable hon
    //       return date.isBefore(from, "day");
    //     } else {
    //       // agar from select hi nahi hua to sab disable na ho
    //       return false;
    //     }
    //   }

    //   return false;
    // },
    // disabledTime(tt) {
    //   if (this.label === "From") {
    //     return false;
    //   }
    //   if (this.label === "To") {
    //     const from = this.min ? moment(this.min) : null;
    //     return from > tt;
    //   }

    //   return false;
    // },

    //
    disabledDate(date) {
      // Agar min pass hua hai
      if (this.min) {
        return moment(date).isBefore(moment(this.min), "day");
      }

      return false;
    },
    disabledTime(date) {
      if (!this.min) return false;

      const minDate = moment(this.min);
      const currentDate = moment(date);

      // sirf same day par time disable karo
      if (!currentDate.isSame(minDate, "day")) {
        return false;
      }

      return {
        disabledHours: () => {
          const hours = [];

          for (let i = 0; i < minDate.hour(); i++) {
            hours.push(i);
          }

          return hours;
        },

        disabledMinutes: (selectedHour) => {
          const minutes = [];

          // same selected hour
          if (selectedHour === minDate.hour()) {
            for (let i = 0; i < minDate.minute(); i++) {
              minutes.push(i);
            }
          }

          return minutes;
        },

        disabledSeconds: () => [],
      };
    },

    //
    emitData() {
      // RANGE
      if (this.range && Array.isArray(this.dt)) {
        const formatted = this.dt.map((d) =>
          moment(d).format("YYYY-MM-DD HH:mm:ss")
        );
        this.$emit("input", formatted);
        this.$emit("change", formatted);

        return;
      }

      // SINGLE
      const dateTime = moment(this.dt).format("YYYY-MM-DD HH:mm:ss");
      this.$emit("input", dateTime);
      this.$emit("change", dateTime);
    },
    // emit
    // 2024-10-15
  },
};
</script>

<style lang="sass" scoped>
.date-time
    width: 100%
    border-radius: 0 !important

:deep i
    margin-top: -1rem

.v-text-field
    font-size: 14px

.form-field
    :deep .v-input__slot
        background: #FFF !important
</style>
